import { render } from "./FHLHomeMain.vue?vue&type=template&id=041e35d1&scoped=true"
import script from "./FHLHomeMain.vue?vue&type=script&lang=js"
export * from "./FHLHomeMain.vue?vue&type=script&lang=js"

import "./FHLHomeMain.vue?vue&type=style&index=0&id=041e35d1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041e35d1"],['__file',"src/views/h5/ai/home/FHLHomeMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "041e35d1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('041e35d1', __exports__)) {
    api.reload('041e35d1', __exports__)
  }
  
  module.hot.accept("./FHLHomeMain.vue?vue&type=template&id=041e35d1&scoped=true", () => {
    api.rerender('041e35d1', render)
  })

}


export default __exports__